// extracted by mini-css-extract-plugin
export var actionButton = "_73-1";
export var actionButtons = "_73-2";
export var actions = "_73-0";
export var aiUnread = "_73-10";
export var alignCenter = "_73-h";
export var backWrapper = "_73-3";
export var cellContainer = "_73-4";
export var checkboxContainer = "_73-5";
export var contentContainer = "_73-6";
export var contentHeader = "_73-8";
export var conversationsTableWrapper = "_73-s";
export var draftReplyBadgeContainer = "_73-m";
export var dropdownItem = "_73-b";
export var dropdownItemsContainer = "_73-a";
export var dropdownTitle = "_73-c";
export var errorIcon = "_73-7";
export var filter = "_73-d";
export var gray = "_73-i";
export var headerActionButtons = "_73-e";
export var headerCheckboxContainer = "_73-f";
export var icon = "_73-j";
export var menuContainer = "_73-k";
export var noMoreTicketsIcon = "_73-12";
export var noMoreTicketsSubText = "_73-13";
export var oneLine = "_73-l";
export var optionsButton = "_73-n";
export var plus = "_73-o";
export var portalButtonsWrapper = "_73-g";
export var red = "_73-p";
export var scrolledTop = "_73-9";
export var search = "_73-q";
export var selectedConversationsCount = "_73-r";
export var spinner = "_73-t";
export var strong = "_73-u";
export var summaryCell = "_73-v";
export var tableContainer = "_73-11";
export var tagContainer = "_73-w";
export var threeDots = "_73-x";
export var twoLines = "_73-y";
export var unread = "_73-z";